import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';

import { AuthService } from '@auth0/auth0-angular';
import { LoadingComponent } from '../shared/components/loading/loading.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LoadingComponent],
})
export class LoginComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private auth = inject(AuthService);

  public ngOnInit() {
    const returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
    // Comes back out of the SDK after the redirect, which navigates to
    // target once the exchange completes.
    this.auth.loginWithRedirect({ appState: { target: returnUrl } }).subscribe();
  }
}
